import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/img/index/titleImg.png'
import _imports_1 from '../assets/img/index/机器人.gif'
import _imports_2 from '../assets/img/index/电脑.gif'
import _imports_3 from '../assets/img/double/title.png'
import _imports_4 from '../assets/img/double/itemLIst.png'
import _imports_5 from '../assets/img/index/list.png'


const _hoisted_1 = { class: "banner" }
const _hoisted_2 = { class: "titleBox" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  src: _imports_5,
  alt: "",
  class: "list"
}
const _hoisted_5 = { class: "messageBox" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]

import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import anime from "animejs";
// 保持原始导入不变
import startBtn from "../assets/img/index/buttonImg.png";
import startBtnActive from "../assets/img/index/buttonImgActive.png";
import home from "../assets/img/home.png";
import homeActive from "../assets/img/homeActive.png";
import oneAudio from "../assets/audio/home/oneAudio.mp3";
import twoAudio from "../assets/audio/home/twoAudio.mp3";
import threeAudio from "../assets/audio/home/threeAudio.mp3";
import fourAudio from "../assets/audio/home/fourAudio.mp3";
import nextImg from "../assets/img/index/nextImg.png";
import nextImgActive from "../assets/img/index/nextImgActive.png";
import nextSetupImg from "../assets/img/reason/submitBtn.png";
import nextSetupActiveImg from "../assets/img/reason/submitBtnActive.png";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter();
const audioPlay = ref<HTMLAudioElement>();
const showTitle = ref(true);
const setups = ref(0);
const tips = ref("你了解佩戴口罩的作用嗎？讓我們一起進行測試。");
const startBtnImg = ref(startBtn);
const homeBtnImg = ref(home);
const audioSrc = ref(oneAudio);
const nextSrc = ref(nextImg);
const nextSetupSrc = ref(nextSetupImg);
const audioPlay02 = ref();
const messageArray = ["你了解佩戴口罩的作用嗎？讓我們一起進行測試。", "我地先準備白紙兩張、卡紙兩張、魚尾夾四個、口罩、顏色溶液、噴水瓶、尺子。", "準備好所有用具，我們就可以開始測試喇。"];
// 新增状态控制
let isManualStop = false;
// 安全播放方法
const safePlay = async (src: string) => {
  try {
    if (!audioPlay.value) return;
    audioPlay02.value.pause();
    // 重置状态
    isManualStop = false;
    audioPlay.value.pause();
    audioPlay.value.currentTime = 0;
    audioPlay.value.src = src;

    // 单次监听加载完成
    await new Promise<void>((resolve, reject) => {
      const successHandler = () => resolve();
      const errorHandler = (e: Event) => reject(e);

      audioPlay.value!.addEventListener("canplaythrough", successHandler, { once: true });
      audioPlay.value!.addEventListener("error", errorHandler, { once: true });
    });

    // 单次监听播放结束
    audioPlay.value.addEventListener("ended", handleAudioEnd, { once: true });

    // 开始播放
    audioPlay.value.volume = 0.5;
    await audioPlay.value.play();
  } catch (error) {
    console.error("播放失败:", error);
    tips.value = "音频加载失败，请刷新重试";
  }
};

// 处理音频结束
const handleAudioEnd = () => {
  if (isManualStop) return;
  if (setups.value < 2) {
    setups.value++;
    audioSrc.value = [oneAudio, twoAudio, threeAudio][setups.value];
    safePlay(audioSrc.value);
    tips.value = messageArray[setups.value];
  }
};

// 进入页面流程
const intoPageFuntion = () => {
  anime({
    targets: ".intoButton",
    translateY: [0, -1200],
    scale: [1, 0],
    duration: 800,
    easing: "linear",
  });
  anime({
    targets: ".indexTitle",
    translateY: [0, -600],
    scale: [1, 0],
    duration: 800,
    easing: "linear",
  });
  showTitle.value = false;
  setups.value = 0;
  safePlay(oneAudio);
};

// 其他原有方法保持不变
const upPage = () => {
  if (setups.value === 3) {
    router.push({ name: "forecast" });
  }
};
const startBtnChageInto = () => {
  startBtnImg.value = startBtnActive;
};
const outBtnChangeOut = () => {
  startBtnImg.value = startBtn;
};
const homeBtnActive = () => {
  homeBtnImg.value = homeActive;
};
const homeBtn = () => {
  homeBtnImg.value = home;
};
const nextBtnActive = () => {
  nextSrc.value = nextImgActive;
};
const nextBtnBtn = () => {
  nextSrc.value = nextImg;
};
const nextSetupBtnActive = () => {
  nextSetupSrc.value = nextSetupActiveImg;
};
const nextSetupBtnBtn = () => {
  nextSetupSrc.value = nextSetupImg;
};
const nextSetup = () => {
  handleAudioEnd();
};
const showList = () => {
  if (setups.value === 2) {
    audioPlay.value.pause();
    setups.value = 3;
    anime({
      targets: ".itemList",
      scale: [0, 1],
      duration: 800,
      easing: "linear",
    });
    anime({
      targets: ".robot",
      opacity: [1, 0],
      duration: 400,
      easing: "linear",
    });
    anime({
      targets: ".messageBox",
      opacity: [1, 0],
      duration: 400,
      easing: "linear",
    });
    anime({
      targets: ".nextButton",
      opacity: [0, 1],
      duration: 400,
      easing: "linear",
    });
  }
};
const bankHome = () => {
  location.reload();
};
// 清理监听
onUnmounted(() => {
  if (audioPlay.value) {
    audioPlay.value.pause();
    audioPlay.value.src = "";
  }
});
onMounted(async () => {
  await audioPlay02.value.play();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "indexTitle"
      }, null, -1)),
      _createElementVNode("img", {
        src: startBtnImg.value,
        alt: "",
        onClick: intoPageFuntion,
        class: "intoButton",
        onMouseenter: startBtnChageInto,
        onMouseleave: outBtnChangeOut
      }, null, 40, _hoisted_3),
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_1,
        alt: "",
        class: "robotGif"
      }, null, -1)),
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_2,
        alt: "",
        class: "jsjGif"
      }, null, -1))
    ], 512), [
      [_vShow, showTitle.value]
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("img", {
      src: _imports_3,
      alt: "",
      class: "title"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("img", {
      src: _imports_4,
      alt: "",
      class: "itemList"
    }, null, -1)),
    _withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [
      [_vShow, setups.value < 3]
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("img", {
      src: _imports_1,
      alt: "",
      class: "robot"
    }, null, -1)),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createTextVNode(_toDisplayString(tips.value) + " ", 1),
      _withDirectives(_createElementVNode("img", {
        src: nextSrc.value,
        alt: "",
        class: "nextBtn",
        onClick: nextSetup,
        onMouseenter: nextBtnActive,
        onMouseleave: nextBtnBtn
      }, null, 40, _hoisted_6), [
        [_vShow, setups.value < 2]
      ])
    ], 512), [
      [_vShow, !showTitle.value]
    ]),
    _withDirectives(_createElementVNode("img", {
      src: nextSetupSrc.value,
      alt: "",
      onClick: showList,
      onMouseenter: nextSetupBtnActive,
      onMouseleave: nextSetupBtnBtn,
      class: "nextSetupImg"
    }, null, 40, _hoisted_7), [
      [_vShow, setups.value === 2]
    ]),
    _withDirectives(_createElementVNode("img", {
      src: nextSetupSrc.value,
      alt: "",
      onClick: upPage,
      class: "nextButton",
      onMouseenter: nextSetupBtnActive,
      onMouseleave: nextSetupBtnBtn
    }, null, 40, _hoisted_8), [
      [_vShow, setups.value === 3]
    ]),
    _createElementVNode("img", {
      src: homeBtnImg.value,
      alt: "",
      class: "homeBtn",
      onMouseenter: homeBtnActive,
      onMouseleave: homeBtn,
      onClick: bankHome
    }, null, 40, _hoisted_9),
    _createElementVNode("audio", {
      ref_key: "audioPlay",
      ref: audioPlay,
      loop: false
    }, [
      _createElementVNode("source", {
        src: audioSrc.value,
        type: "audio/mpeg"
      }, null, 8, _hoisted_10)
    ], 512),
    _createElementVNode("audio", {
      ref_key: "audioPlay02",
      ref: audioPlay02,
      loop: false
    }, [
      _createElementVNode("source", {
        src: _unref(fourAudio),
        type: "audio/mpeg"
      }, null, 8, _hoisted_11)
    ], 512)
  ]))
}
}

})